import { useState, useRef, useEffect } from "react";
import MapView from "./MapView";
import InterventionTechnicien from "./InterventionTechnicien";
import IntDetail from "./IntDetail";
import SAVListView from "./SAVListView";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const STATUT_C = {"in-progress":"#5b6ef8","en_cours":"#5b6ef8","pending":"#f5a623","planifiee":"#f5a623","completed":"#22d3a0","terminee":"#22d3a0","cancelled":"#ef4444","annulee":"#ef4444"};
const STATUT_L = {"in-progress":"En cours","en_cours":"En cours","pending":"Planifié","planifiee":"Planifié","completed":"Terminé","terminee":"Terminé","cancelled":"Annulé","annulee":"Annulé"};

const NAV = [
  {id:"dashboard", ic:"🏠", lbl:"Accueil"},
  {id:"interventions", ic:"🔧", lbl:"Interventions"},
  {id:"carte", ic:"🗺️", lbl:"Carte"},
  {id:"stock", ic:"📦", lbl:"Stock"},
  {id:"sav", ic:"🎫", lbl:"SAV"},
  {id:"flotte", ic:"🚗", lbl:"Flotte"},
];

export default function MobileApp({ user, interventions=[], tickets=[], stock=[], T, onLogout, onUpdated }) {
  const [tab, setTab]         = useState("dashboard");
  const [selInt, setSelInt]   = useState(null);
  const [pvInt, setPvInt]     = useState(null);
  const [techniciens, setTech] = useState([]);
  const [clients, setClients]  = useState([]);
  const [produits, setProduits] = useState([]);
  const [stockTech, setStockTech] = useState([]);
  const [stockDecl, setStockDecl] = useState({produit_id:"",quantite:""});
  const [stockView, setStockView] = useState("vehicule"); // "vehicule" | "entree"
  const [scanInput, setScanInput] = useState("");
  const [scanResult, setScanResult] = useState(null);
  const [scanQty, setScanQty] = useState(1);
  const [scanMsg, setScanMsg] = useState("");
  const [serialNumber, setSerialNumber] = useState(""); // S/N séparé du P/N
  const [scanStep, setScanStep] = useState("pn"); // "pn" | "sn"
  const [debugLog, setDebugLog] = useState([]);
  const [scanLoading, setScanLoading] = useState(false);
  const videoMobRef = useRef(null);
  const readerMobRef = useRef(null);
  const [camActive, setCamActive] = useState(false);
  const [saved, setSaved]     = useState("");

  useEffect(()=>{
    fetch(`${BASE}/users`,{headers:h()}).then(r=>r.json()).then(d=>setTech(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${BASE}/clients`,{headers:h()}).then(r=>r.json()).then(d=>setClients(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${BASE}/stock`,{headers:h()}).then(r=>r.json()).then(d=>setProduits(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${BASE}/vehicules`,{headers:h()}).then(r=>r.json()).then(d=>setVehicules(Array.isArray(d)?d:[])).catch(()=>{});
    if(user?.id) fetch(`${BASE}/stock-technicien/${user.id}`,{headers:h()}).then(r=>r.json()).then(d=>setStockTech(Array.isArray(d)?d:[])).catch(()=>{});
  },[]);

  const saveOk = (msg) => { setSaved(msg); setTimeout(()=>setSaved(""),2500); };

  const [vehicules, setVehicules] = useState([]);
  const [selVeh, setSelVeh]       = useState(null);
  const [vehTab, setVehTab]       = useState("general");
  const [kmInput, setKmInput]     = useState("");
  const [kmSaved, setKmSaved]     = useState(false);
  const [kmPhoto, setKmPhoto]     = useState(null);
  const refKmCam = useRef();
  const [incDesc, setIncDesc]     = useState("");
  const [incPhotos, setIncPhotos] = useState([]);
  const [etatPhotos, setEtatPhotos] = useState([]);
  const [apiDocs, setApiDocs] = useState([]);
  const [lightboxMobile, setLightboxMobile] = useState(null);
  const [releves, setReleves]     = useState([]);
  const [loadingReleves, setLoadingReleves] = useState(false);

  const storeGet  = (k) => { try { return JSON.parse(localStorage.getItem(k)||"{}"); } catch { return {}; } };
  const storeGetA = (k) => { try { return JSON.parse(localStorage.getItem(k)||"[]"); } catch { return []; } };
  const storeSet  = (k,v) => localStorage.setItem(k, JSON.stringify(v));
  const getExtra  = (immat) => ((storeGet("gs_veh_extra"))[immat]||{});
  const getEtat   = (immat) => storeGet("gs_etat_"+immat);

  const compressImg = (file) => new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, 1024/img.width);
        const canvas = document.createElement("canvas");
        canvas.width = img.width*scale; canvas.height = img.height*scale;
        canvas.getContext("2d").drawImage(img,0,0,canvas.width,canvas.height);
        resolve(canvas.toDataURL("image/jpeg",0.72));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

  const dbg = (msg) => setDebugLog(p=>[new Date().toLocaleTimeString()+": "+msg,...p.slice(0,4)]);
  const searchStock = async (val) => {
    if (!val?.trim()) return;
    dbg("Recherche: "+val.trim().slice(0,20));
    setScanLoading(true); setScanResult(null); setScanMsg("🔍 Recherche...");
    try {
      const resp = await fetch(`${BASE}/stock/scan/${encodeURIComponent(val.trim())}`,{headers:h()});
      dbg("Scan HTTP: "+resp.status);
      const res = await resp.json();
      if (!resp.ok || res?.error) {
        setScanResult(null);
        setScanMsg("❌ Non trouvé : "+val.trim());
        setTimeout(()=>setScanMsg(""),4000);
      } else {
        setScanResult(res); setScanQty(1); setScanMsg("");
        if(navigator.vibrate) navigator.vibrate(80);
      }
    } catch(e){ setScanMsg("❌ Erreur réseau: "+e.message); dbg("ERR scan: "+e.message); }
    setScanLoading(false);
  };

  const confirmerEntree = async () => {
    if (!scanResult?.id) return;
    setScanLoading(true);
    try {
      const newQty = (scanResult.quantite||0) + scanQty;
      const token = localStorage.getItem("nexo_token");
      const url = "https://support.gs-group.fr/api/stock/"+scanResult.id+"/quantite";
      const resp = await fetch(url, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer "+token },
        body: JSON.stringify({ quantite: newQty })
      });
      const txt = await resp.text();
      let data;
      try { data = JSON.parse(txt); } catch(e) { data = { error: "Réponse invalide: "+txt.slice(0,50) }; }
      if (!resp.ok || data?.error) {
        setScanMsg("❌ Erreur "+resp.status+": "+(data?.error||txt.slice(0,40)));
      } else {
        setScanMsg("✅ +"+scanQty+" — stock: "+newQty+" unité(s)");
        setScanResult(p=>({...p, quantite: newQty}));
        if(navigator.vibrate) navigator.vibrate([200]);
        if(onUpdated) setTimeout(onUpdated, 500);
      }
    } catch(e) {
      setScanMsg("❌ "+e.message);
    }
    setScanLoading(false);
  };

  const startCamMob = async () => {
    try {
      const { BrowserMultiFormatReader } = await import("@zxing/browser");
      readerMobRef.current = new BrowserMultiFormatReader();
      const devices = await BrowserMultiFormatReader.listVideoInputDevices();
      const backCam = devices.find(d=>d.label.toLowerCase().includes("back")||d.label.toLowerCase().includes("arrière"))||devices[devices.length-1];
      const deviceId = backCam?.deviceId;
      setCamActive(true);
      await readerMobRef.current.decodeFromVideoDevice(deviceId, videoMobRef.current, (result)=>{
        if(result){
          const t=result.getText();
          setScanInput(t); searchStock(t);
        }
      });
    } catch(e){ setScanMsg("Caméra inaccessible"); }
  };

  const stopCamMob = () => {
    try { readerMobRef.current?.reset(); } catch(e){}
    readerMobRef.current = null; setCamActive(false);
  };

  const declareStock = async () => {
    if (!stockDecl.produit_id||stockDecl.quantite==="") return;
    await fetch(`${BASE}/stock-technicien/declarer`,{method:"POST",headers:h(),body:JSON.stringify({...stockDecl,technicien_id:user?.id})});
    const d = await fetch(`${BASE}/stock-technicien/${user.id}`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
    setStockTech(Array.isArray(d)?d:[]);
    setStockDecl({produit_id:"",quantite:""});
    saveOk("✅ Stock déclaré !");
  };

  const openSAV   = tickets.filter(t=>["ouvert","open"].includes(t.statut)).length;
  const enCours   = interventions.filter(i=>["en_cours","in-progress"].includes(i.statut));
  const planifiees = interventions.filter(i=>["planifiee","pending"].includes(i.statut));

  // Vue PV
  if (pvInt) return (
    <InterventionTechnicien T={T} intervention={pvInt}
      onClose={()=>{ setPvInt(null); onUpdated&&onUpdated(); }}
      onUpdated={onUpdated}/>
  );

  // Détail intervention
  if (selInt) return (
    <div style={{minHeight:"100vh",background:T.bg}}>
      <div style={{background:T.card,borderBottom:`1px solid ${T.border}`,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
        <button onClick={()=>setSelInt(null)} style={{background:"none",border:"none",color:T.accent,fontSize:18,cursor:"pointer"}}>← Retour</button>
        <div style={{fontSize:15,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{selInt.titre}</div>
      </div>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:10}}>
        {/* Infos */}
        {[["👤 Client",selInt.client_nom||"—"],["📍 Adresse",selInt.client_adresse||"—"],["🕐 Date",selInt.date_planifiee?new Date(selInt.date_planifiee).toLocaleDateString("fr-FR",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"}):"—"],["🔧 Technicien",selInt.technicien_nom||"Non assigné"],["📋 Statut",STATUT_L[selInt.statut]||selInt.statut]].map(([l,v])=>(
          <div key={l} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:12,color:T.muted}}>{l}</span>
            <span style={{fontSize:13,fontWeight:600,color:T.text}}>{v}</span>
          </div>
        ))}
        {selInt.notes&&<div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"11px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:5}}>Notes</div>
          <div style={{fontSize:13,color:T.text,lineHeight:1.6}}>{selInt.notes}</div>
        </div>}
        {/* Trafic — trajet depuis l'intervention précédente */}
        {selInt.eta_route_distance_km!=null&&(
          <div style={{display:"flex",alignItems:"center",gap:10,background:selInt.eta_route_retard?"#ef444415":"#10b98115",border:`1px solid ${selInt.eta_route_retard?"#ef4444":"#10b981"}40`,borderRadius:12,padding:"11px 14px"}}>
            <span style={{fontSize:18}}>{selInt.eta_route_retard?"⚠️":"✅"}</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:selInt.eta_route_retard?"#ef4444":"#10b981"}}>
                {selInt.eta_route_retard?"Risque de retard":"Trajet dans les temps"}
              </div>
              <div style={{fontSize:11,color:T.muted}}>
                {selInt.eta_route_distance_km} km · {selInt.eta_route_duree_min} min
                {selInt.eta_route_arrivee&&` · arrivée estimée ${new Date(selInt.eta_route_arrivee).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}`}
              </div>
            </div>
          </div>
        )}
        {/* Actions */}
        <button onClick={()=>setPvInt(selInt)}
          style={{padding:"14px",borderRadius:12,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",marginTop:8}}>
          📋 Ouvrir le PV / Démarrer
        </button>
        {selInt.client_adresse&&<a href={`https://maps.google.com/?q=${encodeURIComponent(selInt.client_adresse+" "+selInt.client_ville)}`} target="_blank" rel="noreferrer"
          style={{display:"block",padding:"13px",borderRadius:12,background:"#4285f420",border:"1px solid #4285f440",color:"#4285f4",fontSize:14,fontWeight:700,textAlign:"center",textDecoration:"none"}}>
          📍 Itinéraire Google Maps
        </a>}
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"'Outfit',sans-serif",paddingBottom:72}}>

      {/* Header */}
      <div style={{background:T.card,borderBottom:`1px solid ${T.border}`,padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:30,height:30,borderRadius:9,background:`linear-gradient(135deg,${T.accent},${T.purple})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>⚡</div>
          <div style={{fontSize:14,fontWeight:800,color:T.text}}>Support GS-GROUP</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          {saved&&<div style={{background:T.success,color:"#fff",borderRadius:16,fontSize:10,fontWeight:700,padding:"3px 10px"}}>{saved}</div>}
          {openSAV>0&&<div style={{background:T.danger,color:"#fff",borderRadius:20,fontSize:11,fontWeight:800,padding:"3px 10px"}}>{openSAV} SAV</div>}
          <button onClick={onLogout} style={{background:"none",border:"none",color:T.muted,fontSize:20,cursor:"pointer"}}>↩</button>
        </div>
      </div>

      {/* DASHBOARD */}
      {tab==="dashboard"&&(
        <div style={{padding:16,display:"flex",flexDirection:"column",gap:14}}>
          <div style={{fontSize:17,fontWeight:800,color:T.text}}>Bonjour {user?.prenom} 👋</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {[
              {ic:"⚙️",val:enCours.length,lbl:"En cours",c:T.accent},
              {ic:"📅",val:planifiees.length,lbl:"Planifiées",c:T.warning},
              {ic:"🎫",val:openSAV,lbl:"SAV ouverts",c:T.danger},
              {ic:"✅",val:interventions.filter(i=>["terminee","completed"].includes(i.statut)).length,lbl:"Terminées",c:T.success},
            ].map(s=>(
              <div key={s.lbl} style={{background:T.card,border:`1px solid ${s.c}30`,borderRadius:14,padding:"14px",textAlign:"center"}}>
                <div style={{fontSize:24,marginBottom:4}}>{s.ic}</div>
                <div style={{fontSize:26,fontWeight:800,color:s.c}}>{s.val}</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>{s.lbl}</div>
              </div>
            ))}
          </div>

          {enCours.length>0&&<div>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>⚙️ En cours</div>
            {enCours.map(i=>(
              <div key={i.id} onClick={()=>setSelInt(i)}
                style={{background:T.card,border:`1px solid ${T.accent}40`,borderRadius:12,padding:"12px 14px",marginBottom:8,display:"flex",gap:10,cursor:"pointer"}}>
                <div style={{width:4,borderRadius:2,background:T.accent,flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.titre}</div>
                  <div style={{fontSize:11,color:T.muted}}>👤 {i.client_nom||"—"} · 📍 {i.client_ville||"—"}</div>
                </div>
                <div style={{fontSize:11,fontWeight:700,color:T.accent,background:`${T.accent}20`,padding:"3px 9px",borderRadius:20,alignSelf:"center",flexShrink:0}}>▶</div>
              </div>
            ))}
          </div>}

          {planifiees.length>0&&<div>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>📅 À venir</div>
            {planifiees.slice(0,5).map(i=>(
              <div key={i.id} onClick={()=>setSelInt(i)}
                style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:8,display:"flex",gap:10,cursor:"pointer"}}>
                <div style={{width:4,borderRadius:2,background:T.warning,flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.titre}</div>
                  <div style={{fontSize:11,color:T.muted}}>📍 {i.client_ville||"—"} · {i.date_planifiee?new Date(i.date_planifiee).toLocaleDateString("fr-FR",{day:"numeric",month:"short"}):"—"}</div>
                </div>
              </div>
            ))}
          </div>}
        </div>
      )}

      {/* INTERVENTIONS */}
      {tab==="interventions"&&(
        <div style={{padding:16}}>
          <div style={{fontSize:17,fontWeight:800,color:T.text,marginBottom:14}}>🔧 Interventions</div>
          {["en_cours","in-progress","planifiee","pending","terminee","completed"].map(statut=>{
            const items = interventions.filter(i=>i.statut===statut);
            if (items.length===0) return null;
            const color = STATUT_C[statut]||T.muted;
            return(
              <div key={statut} style={{marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <div style={{height:1,width:10,background:`${color}60`}}/>
                  <span style={{fontSize:12,fontWeight:700,color}}>{STATUT_L[statut]}</span>
                  <span style={{fontSize:10,background:`${color}20`,color,padding:"1px 8px",borderRadius:20,fontWeight:700}}>{items.length}</span>
                  <div style={{flex:1,height:1,background:`${color}30`}}/>
                </div>
                {items.map(i=>(
                  <div key={i.id} onClick={()=>setSelInt(i)}
                    style={{background:T.card,border:`1px solid ${T.border}`,borderLeft:`4px solid ${color}`,borderRadius:"0 12px 12px 0",padding:"12px 14px",marginBottom:7,cursor:"pointer"}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.titre}</div>
                    <div style={{fontSize:11,color:T.muted}}>👤 {i.client_nom||"—"} · {i.date_planifiee?new Date(i.date_planifiee).toLocaleDateString("fr-FR",{day:"numeric",month:"short"}):"—"}</div>
                  </div>
                ))}
              </div>
            );
          })}
          {interventions.length===0&&<div style={{textAlign:"center",padding:40,color:T.muted}}>Aucune intervention</div>}
        </div>
      )}

      {/* CARTE */}
      {tab==="carte"&&(
        <div style={{height:"calc(100vh - 120px)"}}>
          <MapView T={T} interventions={interventions} tickets={tickets}/>
        </div>
      )}

      {/* STOCK */}
      {tab==="stock"&&(
        <div style={{padding:16,display:"flex",flexDirection:"column",gap:14}}>
          {/* Toggle */}
          <div style={{display:"flex",background:T.card,borderRadius:12,border:`1px solid ${T.border}`,overflow:"hidden"}}>
            {[["vehicule","🚗 Stock véhicule"],["entree","📦 Entrée stock"]].map(([v,l])=>(
              <button key={v} onClick={()=>{setStockView(v);if(v!=="entree")stopCamMob();}}
                style={{flex:1,padding:"12px 8px",background:stockView===v?T.accentDim:"transparent",border:"none",color:stockView===v?T.accent:T.muted,fontSize:13,fontWeight:stockView===v?700:500,cursor:"pointer"}}>
                {l}
              </button>
            ))}
          </div>

          {/* ── ENTRÉE STOCK ── */}
          {stockView==="entree"&&(<>
            {/* Zone de scan - input auto-focus */}
            <div style={{background:T.card,border:`2px solid ${T.accent}`,borderRadius:16,padding:20,display:"flex",flexDirection:"column",gap:14,alignItems:"center"}}>
              <div style={{fontSize:40}}>📦</div>
              <div style={{fontSize:13,fontWeight:700,color:T.text,textAlign:"center"}}>Scannez le code P/N du produit</div>
              <div style={{fontSize:11,color:T.muted,textAlign:"center"}}>Utilisez votre douchette, appli scanner ou saisie manuelle</div>
              <input
                autoFocus
                value={scanInput}
                onChange={e=>{ setScanInput(e.target.value); }}
                onKeyDown={e=>{ if(e.key==="Enter"&&scanInput.trim()){ searchStock(scanInput.trim()); } }}
                placeholder="Code-barres / P/N..."
                style={{width:"100%",background:T.bg,border:`2px solid ${T.accent}`,borderRadius:12,padding:"14px 16px",color:T.text,fontSize:18,fontWeight:700,textAlign:"center",outline:"none",letterSpacing:2}}
              />
              <div style={{display:"flex",gap:10,width:"100%"}}>
                <button onClick={startCamMob} style={{flex:1,padding:"12px",borderRadius:10,background:T.accentDim,border:`1px solid ${T.accent}`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer"}}>
                  📷 Caméra
                </button>
                <button onClick={()=>searchStock(scanInput.trim())} disabled={!scanInput.trim()||scanLoading}
                  style={{flex:2,padding:"12px",borderRadius:10,background:scanInput.trim()?T.accent:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                  {scanLoading?"🔍...":"🔍 Identifier"}
                </button>
              </div>
            </div>
            {/* Caméra optionnelle */}
            {camActive&&(
              <div style={{background:"#000",borderRadius:14,overflow:"hidden",position:"relative",aspectRatio:"4/3"}}>
                <video ref={videoMobRef} style={{width:"100%",height:"100%",objectFit:"cover"}} playsInline muted/>
                <div style={{position:"absolute",left:"10%",right:"10%",top:"50%",height:2,background:`linear-gradient(90deg,transparent,${T.accent},transparent)`,animation:"scanLine 2s ease-in-out infinite"}}/>
                <style>{`@keyframes scanLine{0%{top:20%}50%{top:80%}100%{top:20%}}`}</style>
                <button onClick={stopCamMob} style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.7)",border:"none",color:"#fff",borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer"}}>✕ Stop</button>
              </div>
            )}

            {/* Message */}
            {scanMsg&&<div style={{textAlign:"center",padding:"10px 14px",borderRadius:10,background:scanMsg.includes("✅")?"rgba(16,185,129,0.1)":"rgba(239,68,68,0.1)",color:scanMsg.includes("✅")?"#10b981":"#ef4444",fontWeight:700,fontSize:14}}>{scanMsg}</div>}

            {/* Produit trouvé */}
            {scanResult&&(
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16,display:"flex",flexDirection:"column",gap:12}}>
                <div style={{fontSize:12,fontWeight:700,color:"#10b981",textTransform:"uppercase"}}>✅ Produit trouvé</div>
                  <div style={{fontSize:9,color:T.muted,fontFamily:"monospace"}}>ID: {scanResult.id||"UNDEFINED"}</div>
                <div style={{fontSize:14,fontWeight:700,color:T.text,lineHeight:1.3}}>{scanResult.designation||scanResult.nom}</div>
                <div style={{fontSize:12,color:T.muted,fontFamily:"monospace"}}>{scanResult.reference} · {scanResult.categorie}</div>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <span style={{fontSize:12,color:T.muted}}>Stock actuel</span>
                  <span style={{fontSize:18,fontWeight:800,color:T.text}}>{scanResult.quantite} unités</span>
                </div>

                {/* P/N */}
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:T.mutedL,textTransform:"uppercase",display:"block",marginBottom:4}}>P/N — Référence produit</label>
                  <div style={{display:"flex",gap:6}}>
                    <input value={scanInput} onChange={e=>setScanInput(e.target.value)}
                      placeholder="Ex: 1.0.99.44.10479.9001"
                      style={{flex:1,background:T.bg,border:`1px solid ${T.accent}60`,borderRadius:9,padding:"10px 12px",color:T.accent,fontFamily:"monospace",fontSize:13,fontWeight:600,outline:"none"}}
                      onKeyDown={e=>e.key==="Enter"&&searchStock(scanInput)}/>
                    <button onClick={()=>searchStock(scanInput)} disabled={!scanInput||scanLoading}
                      style={{padding:"10px 14px",borderRadius:9,background:T.accent,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>🔍</button>
                  </div>
                </div>

                {/* Quantité */}
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:T.mutedL,textTransform:"uppercase",display:"block",marginBottom:8}}>Quantité à ajouter</label>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <button onClick={()=>setScanQty(q=>Math.max(1,q-1))} style={{width:50,height:50,borderRadius:10,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:28,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>
                    <input type="number" value={scanQty} min={1} onChange={e=>setScanQty(Math.max(1,parseInt(e.target.value)||1))}
                      style={{flex:1,textAlign:"center",background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px",color:T.text,fontSize:28,fontWeight:800,outline:"none"}}/>
                    <button onClick={()=>setScanQty(q=>q+1)} style={{width:50,height:50,borderRadius:10,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:28,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                  </div>
                </div>

                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 12px",background:T.bg,borderRadius:9}}>
                  <span style={{fontSize:12,color:T.muted}}>Après ajout</span>
                  <span style={{fontSize:20,fontWeight:800,color:T.accent}}>{(scanResult.quantite||0)+scanQty} unités</span>
                </div>

                <button onClick={confirmerEntree} disabled={scanLoading}
                  style={{padding:14,borderRadius:12,background:T.accent,border:"none",color:"#fff",fontSize:16,fontWeight:800,cursor:"pointer",opacity:scanLoading?0.7:1}}>
                  {scanLoading?"...":"✅ Confirmer l'entrée"}
                </button>
              </div>
            )}
          </>)}

          {/* ── STOCK VÉHICULE ── */}
          {stockView==="vehicule"&&(<>
            <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>Déclarer un produit</div>
              <select value={stockDecl.produit_id} onChange={e=>setStockDecl(p=>({...p,produit_id:e.target.value}))}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,outline:"none",width:"100%",marginBottom:10}}>
                <option value="">— Choisir un produit —</option>
                {produits.map(p=><option key={p.id} value={p.id}>{p.designation}</option>)}
              </select>
              <div style={{display:"flex",gap:10}}>
                <input type="number" min="0" value={stockDecl.quantite} onChange={e=>setStockDecl(p=>({...p,quantite:e.target.value}))} placeholder="Quantité"
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:16,fontWeight:700,outline:"none",flex:1}}/>
                <button onClick={declareStock} disabled={!stockDecl.produit_id||stockDecl.quantite===""}
                  style={{padding:"10px 18px",borderRadius:10,background:stockDecl.produit_id&&stockDecl.quantite?T.accent:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>✅</button>
              </div>
            </div>
            {stockTech.length===0&&<div style={{textAlign:"center",padding:30,color:T.muted}}><div style={{fontSize:32,marginBottom:8}}>📦</div><div>Stock vide — déclarez vos produits</div></div>}
            {stockTech.map(s=>(
              <div key={s.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>{s.designation}</div>
                  <div style={{fontSize:11,color:T.muted}}>{s.categorie||"—"}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:24,fontWeight:800,color:s.quantite>0?T.success:T.danger}}>{s.quantite}</div>
                  <div style={{fontSize:10,color:T.muted}}>unités</div>
                </div>
              </div>
            ))}
          </>)}
        </div>
      )}

      {/* SAV */}
      {tab==="sav"&&(
        <div style={{padding:16}}>
          <div style={{fontSize:17,fontWeight:800,color:T.text,marginBottom:14}}>🎫 SAV & Tickets</div>
          {tickets.length===0&&<div style={{textAlign:"center",padding:40,color:T.muted}}>Aucun ticket</div>}
          {tickets.map(t=>{
            const sc = {ouvert:"#ef4444",open:"#ef4444",en_cours:"#f5a623","in-progress":"#f5a623",resolu:"#22d3a0",resolved:"#22d3a0"}[t.statut]||T.muted;
            return(
              <div key={t.id} style={{background:T.card,border:`1px solid ${sc}30`,borderLeft:`4px solid ${sc}`,borderRadius:"0 12px 12px 0",padding:"12px 14px",marginBottom:8}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:5}}>
                  <span style={{fontSize:10,fontWeight:700,color:sc,background:`${sc}20`,padding:"2px 8px",borderRadius:20}}>{t.statut}</span>
                  <span style={{fontSize:10,color:T.muted}}>{t.priorite}</span>
                  <span style={{fontSize:10,color:T.muted,marginLeft:"auto"}}>{new Date(t.created_at).toLocaleDateString("fr-FR")}</span>
                </div>
                <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:3}}>{t.objet}</div>
                <div style={{fontSize:11,color:T.muted}}>📍 {t.ville||"—"} · 👤 {t.client_nom||"—"}</div>
              </div>
            );
          })}
        </div>
      )}


      {/* FLOTTE — Liste */}
      {tab==="flotte"&&!selVeh&&(
        <div style={{padding:16,paddingBottom:90,display:"flex",flexDirection:"column",gap:10}}>
          <div style={{fontSize:17,fontWeight:800,color:T.text}}>🚗 Flotte GS-GROUP</div>
          {/* Mon véhicule assigné */}
          {(()=>{
            const monVeh = vehicules.find(v=>{
              const ex=getExtra(v.immatriculation);
              const fullName=((user?.prenom||"")+" "+(user?.nom||"")).trim().toUpperCase();
              return ex.titulaire&&ex.titulaire.toUpperCase()===fullName;
            });
            if(!monVeh)return null;
            const ex=getExtra(monVeh.immatriculation);
            const ev=getEtat(monVeh.immatriculation);
            return(
              <div style={{background:`linear-gradient(135deg,${T.accent}15,#8b5cf615)`,border:`2px solid ${T.accent}`,borderRadius:16,overflow:"hidden",marginBottom:4}}>
                <div style={{padding:"10px 14px",background:`${T.accent}10`,borderBottom:`1px solid ${T.accent}30`,display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:14,fontWeight:800,color:T.accent}}>🚗 Mon véhicule</span>
                  {ex.statut&&<span style={{fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:20,background:`${T.accent}20`,color:T.accent}}>{ex.statut==="attribuee"?"Attribuée":ex.statut}</span>}
                </div>
                <div style={{padding:"12px 14px",display:"flex",gap:12,alignItems:"center"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:16,fontWeight:800,color:T.text}}>{monVeh.marque} {monVeh.modele}</div>
                    <div style={{fontFamily:"monospace",fontSize:15,fontWeight:800,color:T.accent,letterSpacing:"2px",marginTop:2}}>{monVeh.immatriculation}</div>
                    {monVeh.kilometrage_actuel>0&&<div style={{fontSize:12,color:T.muted,marginTop:4}}>📏 {parseInt(monVeh.kilometrage_actuel).toLocaleString("fr-FR")} km</div>}
                    {ev.etat&&<div style={{fontSize:11,marginTop:2,color:ev.etat==="bon"?"#10b981":ev.etat==="moyen"?"#f59e0b":"#ef4444"}}>{ev.etat==="bon"?"✅ Bon état":ev.etat==="moyen"?"⚠️ Moyen":"❌ Mauvais"}</div>}
                  </div>
                  <button onClick={()=>{setSelVeh(monVeh);setVehTab("km");setKmInput("");setKmSaved(false);setIncDesc("");setIncPhotos([]);setApiDocs([]);setEtatPhotos([]);fetch(`${BASE}/vehicules/${monVeh.id}/photos?categorie=etat`,{headers:h()}).then(r=>r.json()).then(d=>setEtatPhotos((Array.isArray(d)?d:[]).map(p=>({id:p.id,url:p.url})))).catch(()=>{});fetch(`${BASE}/vehicules/${monVeh.id}/photos`,{headers:h()}).then(r=>r.json()).then(d=>setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"))).catch(()=>{});}}
                    style={{padding:"12px 18px",borderRadius:12,background:`linear-gradient(135deg,${T.accent},#8b5cf6)`,border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",minHeight:48,WebkitTapHighlightColor:"transparent"}}>
                    Gérer →
                  </button>
                </div>
                {/* Boutons rapides */}
                <div style={{padding:"0 14px 12px",display:"flex",gap:8}}>
                  <button onClick={()=>{setSelVeh(monVeh);setVehTab("km");setKmInput("");setKmSaved(false);setApiDocs([]);setEtatPhotos([]);fetch(`${BASE}/vehicules/${monVeh.id}/photos`,{headers:h()}).then(r=>r.json()).then(d=>setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"))).catch(()=>{});}}
                    style={{flex:1,padding:"10px",borderRadius:10,background:"#10b98115",border:"1px solid #10b98130",color:"#10b981",fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44,WebkitTapHighlightColor:"transparent"}}>
                    📏 Km
                  </button>
                  <button onClick={()=>{setSelVeh(monVeh);setVehTab("incident");setIncDesc("");setIncPhotos([]);setApiDocs([]);setEtatPhotos([]);}}
                    style={{flex:1,padding:"10px",borderRadius:10,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44,WebkitTapHighlightColor:"transparent"}}>
                    ⚠️ Incident
                  </button>
                  <button onClick={()=>{setSelVeh(monVeh);setVehTab("docs");setApiDocs([]);setEtatPhotos([]);fetch(`${BASE}/vehicules/${monVeh.id}/photos`,{headers:h()}).then(r=>r.json()).then(d=>setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"))).catch(()=>{});}}
                    style={{flex:1,padding:"10px",borderRadius:10,background:`${T.accent}15`,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44,WebkitTapHighlightColor:"transparent"}}>
                    📄 Docs
                  </button>
                </div>
              </div>
            );
          })()}
          {vehicules.length>0&&<div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginTop:4}}>Tous les véhicules</div>}
          {vehicules.length===0&&<div style={{textAlign:"center",padding:40,color:T.muted}}><div style={{fontSize:40,marginBottom:10}}>🚗</div><div>Aucun véhicule</div></div>}
          {vehicules.map(v=>{
            const ex=getExtra(v.immatriculation);
            const ev=getEtat(v.immatriculation);
            const nInc=storeGetA("gs_incidents_"+v.immatriculation).length;
            const stMap={attribuee:{c:"#10b981",lbl:"Attribuée"},vacante:{c:"#f59e0b",lbl:"Vacante"},location:{c:"#3b82f6",lbl:"Location"},hors_service:{c:"#ef4444",lbl:"H.S."}};
            const st=stMap[ex.statut||"attribuee"]||{c:T.muted,lbl:"—"};
            return(
              <div key={v.id} onClick={()=>{setSelVeh(v);setVehTab("general");setKmInput("");setKmSaved(false);setIncDesc("");setIncPhotos([]);setApiDocs([]);setEtatPhotos([]);
                fetch(`${BASE}/vehicules/${v.id}/photos?categorie=etat`,{headers:h()}).then(r=>r.json()).then(d=>setEtatPhotos((Array.isArray(d)?d:[]).map(p=>({id:p.id,url:p.url})))).catch(()=>{});
                fetch(`${BASE}/vehicules/${v.id}/photos`,{headers:h()}).then(r=>r.json()).then(d=>setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"))).catch(()=>{});}}
                style={{background:T.card,border:`1.5px solid ${T.border}`,borderRadius:14,overflow:"hidden",cursor:"pointer"}}>
                <div style={{padding:"12px 14px",background:`${T.accent}08`,borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:3}}>
                      <span style={{fontSize:14,fontWeight:800,color:T.text}}>{v.marque} {v.modele}</span>
                      <span style={{fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:20,background:`${st.c}20`,color:st.c}}>{st.lbl}</span>
                    </div>
                    <div style={{fontFamily:"monospace",fontWeight:800,fontSize:15,letterSpacing:"2px",color:T.accent}}>{v.immatriculation}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    {v.kilometrage_actuel>0&&<div><span style={{fontSize:14,fontWeight:800,color:T.text}}>{parseInt(v.kilometrage_actuel).toLocaleString("fr-FR")}</span><span style={{fontSize:9,color:T.muted}}> km</span></div>}
                    {nInc>0&&<div style={{fontSize:9,fontWeight:700,color:"#ef4444"}}>⚠ {nInc} incident{nInc>1?"s":""}</div>}
                  </div>
                </div>
                <div style={{padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:12,color:T.muted}}>👤 {ex.titulaire||"Non assigné"}</div>
                    {ev.etat&&<div style={{fontSize:11,marginTop:2,color:ev.etat==="bon"?"#10b981":ev.etat==="moyen"?"#f59e0b":"#ef4444"}}>{ev.etat==="bon"?"✅ Bon":ev.etat==="moyen"?"⚠️ Moyen":"❌ Mauvais"}</div>}
                  </div>
                  <span style={{fontSize:18,color:T.muted}}>›</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* FLOTTE — Détail véhicule */}
      {tab==="flotte"&&selVeh&&(
        <div style={{display:"flex",flexDirection:"column",minHeight:"100vh",background:T.bg}}>
          <div style={{background:T.card,borderBottom:`1px solid ${T.border}`,padding:"12px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
            <button onClick={()=>setSelVeh(null)} style={{background:"none",border:"none",color:T.accent,fontSize:22,cursor:"pointer",minWidth:40,minHeight:40,display:"flex",alignItems:"center",justifyContent:"center"}}>←</button>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:15,fontWeight:800,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{selVeh.marque} {selVeh.modele}</div>
              <div style={{fontFamily:"monospace",fontSize:14,fontWeight:800,color:T.accent,letterSpacing:"2px"}}>{selVeh.immatriculation}</div>
            </div>
          </div>
          <div style={{display:"flex",borderBottom:`1px solid ${T.border}`,background:T.card,flexShrink:0,overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
            {[["general","📋 Général"],["km","📏 Km"],["incident","⚠️ Incident"],["docs","📄 Docs"]].map(([id,lbl])=>(
              <button key={id}
                style={{padding:"12px 16px",background:vehTab===id?T.accentDim:"transparent",border:"none",borderBottom:vehTab===id?`2px solid ${T.accent}`:"2px solid transparent",color:vehTab===id?T.accent:T.muted,fontSize:13,fontWeight:vehTab===id?700:500,cursor:"pointer",whiteSpace:"nowrap",minHeight:48,WebkitTapHighlightColor:"transparent"}}
                onClick={()=>{setVehTab(id);if(id==="km"){setLoadingReleves(true);fetch(`${BASE}/vehicules/${selVeh.id}/releves`,{headers:h()}).then(r=>r.json()).then(d=>{setReleves(Array.isArray(d)?d:[]);setLoadingReleves(false);}).catch(()=>setLoadingReleves(false));}if(id==="general"){fetch(`${BASE}/vehicules/${selVeh.id}/photos?categorie=etat`,{headers:h()}).then(r=>r.json()).then(d=>{setEtatPhotos((Array.isArray(d)?d:[]).map(p=>({id:p.id,url:p.url})));}).catch(()=>{});}if(id==="docs"){fetch(`${BASE}/vehicules/${selVeh.id}/photos`,{headers:h()}).then(r=>r.json()).then(d=>{setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"));}).catch(()=>{});}}}
              >
                {lbl}
              </button>
            ))}
          </div>
          <div style={{flex:1,overflowY:"auto",padding:16,paddingBottom:90,WebkitOverflowScrolling:"touch"}}>
            {/* Général */}
            {vehTab==="general"&&(()=>{
              const ex=getExtra(selVeh.immatriculation);
              const ev=getEtat(selVeh.immatriculation);
              return(<div style={{display:"flex",flexDirection:"column",gap:12}}>
                <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:14}}>
                  {[["Titulaire",ex.titulaire||"Non assigné"],["Statut",{attribuee:"Attribuée",vacante:"Vacante",location:"Location",hors_service:"H.S."}[ex.statut||"attribuee"]||"—"],["Double clés",ex.double_cles==="oui"?"✅ OUI":"❌ NON"],["Kilométrage",selVeh.kilometrage_actuel?parseInt(selVeh.kilometrage_actuel).toLocaleString("fr-FR")+" km":"—"]].map(([l,v])=>(
                    <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${T.border}20`}}>
                      <span style={{fontSize:13,color:T.muted}}>{l}</span>
                      <span style={{fontSize:13,fontWeight:700,color:T.text}}>{v}</span>
                    </div>
                  ))}
                  {ex.notes&&<div style={{marginTop:8,fontSize:12,color:T.muted,fontStyle:"italic"}}>📝 {ex.notes}</div>}
                </div>
                <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,marginBottom:8,textTransform:"uppercase"}}>État général</div>
                  {ev.etat&&<div style={{fontSize:15,fontWeight:700,marginBottom:6,color:ev.etat==="bon"?"#10b981":ev.etat==="moyen"?"#f59e0b":"#ef4444"}}>{ev.etat==="bon"?"✅ Bon état":ev.etat==="moyen"?"⚠️ Moyen":"❌ Mauvais état"}</div>}
                  {ev.description&&<div style={{fontSize:12,color:T.muted,marginBottom:10,fontStyle:"italic"}}>{ev.description}</div>}
                  {etatPhotos.length>0&&(
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
                      {etatPhotos.map((ph,i)=>(<div key={i} onClick={()=>setLightboxMobile(ph.url||ph)} style={{position:"relative",width:90,height:90,borderRadius:10,overflow:"hidden",flexShrink:0,cursor:"pointer"}}><img src={ph.url||ph} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/></div>)||(
                        <div key={i} style={{position:"relative",width:90,height:90,borderRadius:10,overflow:"hidden",flexShrink:0}}>
                          <img src={ph.url||ph} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>
                          <button onClick={async()=>{
                            if(etatPhotos[i]?.id){await fetch(`${BASE}/vehicules/${selVeh.id}/photos/${etatPhotos[i].id}`,{method:"DELETE",headers:h()});}
                            const updated=etatPhotos.filter((_,j)=>j!==i);
                            setEtatPhotos(updated);
                          }} style={{position:"absolute",top:3,right:3,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:5,cursor:"pointer",fontSize:14,padding:"2px 6px",minWidth:28,minHeight:28,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{display:"flex",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                    <label style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:7,padding:"13px",borderRadius:10,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",minHeight:48,WebkitTapHighlightColor:"transparent"}}>
                      📷 Caméra
                      <input type="file" accept="image/*" capture="environment" multiple onChange={async e=>{
                        if(!e.target.files.length)return;
                        saveOk("⏳ Compression...");
                        const uploadPhotos = async (imgs) => {
                          const tok=localStorage.getItem("nexo_token");
                          // Envoyer en base64 via JSON
                          const res=await fetch(`${BASE}/vehicules/${selVeh.id}/photos`,{
                            method:"POST",
                            headers:{Authorization:"Bearer "+tok,"Content-Type":"application/json"},
                            body:JSON.stringify({photos:imgs,categorie:"etat"})
                          }).then(r=>r.json()).catch(e=>({error:e.message}));
                          return res;
                        };
                        const imgs=await Promise.all([...e.target.files].map(compressImg));
                        const res=await uploadPhotos(imgs);
                        if(res.uploaded||res.count){
                          const d=await fetch(`${BASE}/vehicules/${selVeh.id}/photos?categorie=etat`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
                          setEtatPhotos((Array.isArray(d)?d:[]).map(p=>({id:p.id,url:p.url})));
                          saveOk("✅ "+(res.count||imgs.length)+" photo(s) enregistrée(s) !");
                        } else {
                          saveOk("❌ "+(res.error||"Erreur upload"));
                        }
                        e.target.value="";
                      }} style={{display:"none"}}/>
                    </label>
                    <label style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:7,padding:"13px",borderRadius:10,background:`#8b5cf615`,border:"1px solid #8b5cf630",color:"#8b5cf6",fontSize:13,fontWeight:700,cursor:"pointer",minHeight:48,WebkitTapHighlightColor:"transparent"}}>
                      📁 Galerie
                      <input type="file" accept="image/*" multiple onChange={async e=>{
                        if(!e.target.files.length)return;
                        saveOk("⏳ Compression...");
                        const imgs=await Promise.all([...e.target.files].map(compressImg));
                        const tok=localStorage.getItem("nexo_token");
                        const res=await fetch(`${BASE}/vehicules/${selVeh.id}/photos`,{
                          method:"POST",
                          headers:{Authorization:"Bearer "+tok,"Content-Type":"application/json"},
                          body:JSON.stringify({photos:imgs,categorie:"etat"})
                        }).then(r=>r.json()).catch(e=>({error:e.message}));
                        if(res.uploaded||res.count){
                          const d=await fetch(`${BASE}/vehicules/${selVeh.id}/photos?categorie=etat`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
                          setEtatPhotos((Array.isArray(d)?d:[]).map(p=>({id:p.id,url:p.url})));
                          saveOk("✅ "+(res.count||imgs.length)+" photo(s) enregistrée(s) !");
                        } else {
                          saveOk("❌ "+(res.error||"Erreur upload"));
                        }
                        e.target.value="";
                      }} style={{display:"none"}}/>
                    </label>
                  </div>
                </div>
              </div>);
            })()}

            {/* Km */}
            {vehTab==="km"&&(
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:16}}>
                  <div style={{fontSize:12,color:T.muted,marginBottom:4}}>Kilométrage actuel</div>
                  <div style={{fontSize:28,fontWeight:800,color:T.text,marginBottom:16}}>{selVeh.kilometrage_actuel?parseInt(selVeh.kilometrage_actuel).toLocaleString("fr-FR")+" km":"—"}</div>
                  <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:6,textTransform:"uppercase"}}>Nouveau relevé *</label>
                  <input type="number" inputMode="numeric" value={kmInput} onChange={e=>setKmInput(e.target.value)}
                    placeholder="Ex: 125000"
                    style={{background:T.bg,border:`2px solid ${kmInput?T.accent:T.border}`,borderRadius:10,padding:"14px 16px",color:T.text,fontSize:22,fontWeight:800,outline:"none",width:"100%",boxSizing:"border-box",marginBottom:14}}/>
                  <input ref={refKmCam} type="file" accept="image/*" capture="environment" onChange={async e=>{
                    if(!e.target.files[0])return;
                    const img=await compressImg(e.target.files[0]);
                    setKmPhoto(img);
                    saveOk("✅ Photo prête !");
                    e.target.value="";
                  }} style={{display:"none"}}/>
                  <button onClick={()=>refKmCam.current.click()}
                    style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"12px",borderRadius:10,background:kmPhoto?"#10b98115":"#3b82f615",border:`1px solid ${kmPhoto?"#10b98130":"#3b82f630"}`,color:kmPhoto?"#10b981":"#3b82f6",fontSize:13,fontWeight:700,cursor:"pointer",minHeight:46,marginBottom:kmPhoto?8:14,width:"100%",WebkitTapHighlightColor:"transparent"}}>
                    {kmPhoto?"✅ Photo prête — retoucher":"📷 Photo du compteur"}
                  </button>
                  {kmPhoto&&(
                    <div style={{position:"relative",width:"100%",borderRadius:10,overflow:"hidden",marginBottom:14,maxHeight:160}}>
                      <img src={kmPhoto} style={{width:"100%",objectFit:"cover",maxHeight:160}} alt="compteur"/>
                      <button onClick={()=>setKmPhoto(null)} style={{position:"absolute",top:6,right:6,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:20,padding:"3px 10px",fontSize:12,cursor:"pointer"}}>✕ Supprimer</button>
                    </div>
                  )}
                  <button onClick={async()=>{
                    if(!kmInput)return;
                    await fetch(`${BASE}/vehicules/${selVeh.id}/releve`,{method:"POST",headers:h(),body:JSON.stringify({kilometrage:kmInput,notes:"",photo_url:kmPhoto||null})});
                    setKmPhoto(null);
                    const d=await fetch(`${BASE}/vehicules`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
                    setVehicules(Array.isArray(d)?d:[]);
                    const upd=d.find(v=>v.id===selVeh.id); if(upd)setSelVeh(upd);
                    // Recharger historique
                    const rel=await fetch(`${BASE}/vehicules/${selVeh.id}/releves`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
                    setReleves(Array.isArray(rel)?rel:[]);
                    setKmSaved(true); saveOk("✅ Relevé enregistré !");
                  }} disabled={!kmInput}
                    style={{width:"100%",padding:16,borderRadius:12,background:kmInput?"#10b981":T.border,border:"none",color:"#fff",fontSize:16,fontWeight:800,cursor:kmInput?"pointer":"not-allowed",minHeight:54,WebkitTapHighlightColor:"transparent"}}>
                    {kmSaved?"✅ Enregistré !":"📏 Enregistrer le relevé"}
                  </button>
                </div>
                {/* Historique + Courbe */}
                {loadingReleves&&<div style={{textAlign:"center",padding:20,color:T.muted}}>⏳ Chargement...</div>}
                {!loadingReleves&&releves.length>0&&(()=>{
                  const sorted=[...releves].sort((a,b)=>new Date(a.date_releve)-new Date(b.date_releve));
                  const kms=sorted.map(r=>parseInt(r.kilometrage));
                  const dates=sorted.map(r=>new Date(r.date_releve).toLocaleDateString("fr-FR",{day:"2-digit",month:"2-digit"}));
                  const minKm=Math.min(...kms), maxKm=Math.max(...kms);
                  const range=maxKm-minKm||1;
                  const W=300, H=120, PAD=10;
                  const pts=kms.map((k,i)=>({
                    x:PAD+(i/(kms.length-1||1))*(W-PAD*2),
                    y:H-PAD-(k-minKm)/range*(H-PAD*2)
                  }));
                  const path=pts.map((p,i)=>(i===0?`M${p.x},${p.y}`:`L${p.x},${p.y}`)).join(" ");
                  const fillPath=path+` L${pts[pts.length-1].x},${H-PAD} L${pts[0].x},${H-PAD} Z`;
                  return(
                  <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:14,marginTop:12}}>
                    <div style={{fontSize:12,fontWeight:700,color:T.muted,marginBottom:10,textTransform:"uppercase"}}>📈 Courbe kilométrique ({releves.length} relevés)</div>
                    {kms.length>1&&(
                      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:H,overflow:"visible",marginBottom:10}}>
                        <defs>
                          <linearGradient id="kmGrad" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor={T.accent} stopOpacity="0.3"/>
                            <stop offset="100%" stopColor={T.accent} stopOpacity="0.02"/>
                          </linearGradient>
                        </defs>
                        <path d={fillPath} fill="url(#kmGrad)"/>
                        <path d={path} fill="none" stroke={T.accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        {pts.map((p,i)=><circle key={i} cx={p.x} cy={p.y} r="4" fill={T.accent}/>)}
                        {/* Labels dates début/fin */}
                        <text x={PAD} y={H} fill={T.muted} fontSize="9" textAnchor="start">{dates[0]}</text>
                        {dates.length>1&&<text x={W-PAD} y={H} fill={T.muted} fontSize="9" textAnchor="end">{dates[dates.length-1]}</text>}
                        {/* Labels km min/max */}
                        <text x={PAD} y={PAD+8} fill={T.accent} fontSize="9" fontWeight="bold">{maxKm.toLocaleString("fr-FR")}</text>
                        <text x={PAD} y={H-PAD-2} fill={T.muted} fontSize="9">{minKm.toLocaleString("fr-FR")}</text>
                      </svg>
                    )}
                    {/* Tableau derniers relevés */}
                    <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:200,overflowY:"auto"}}>
                      {[...releves].sort((a,b)=>new Date(b.date_releve)-new Date(a.date_releve)).slice(0,20).map((r,i)=>(
                        <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:i===0?`${T.accent}10`:T.bg,borderRadius:8,border:i===0?`1px solid ${T.accent}30`:"none"}}>
                          <div>
                            <div style={{fontSize:13,fontWeight:700,color:T.text}}>{parseInt(r.kilometrage).toLocaleString("fr-FR")} km</div>
                            {r.technicien_nom&&<div style={{fontSize:10,color:T.muted}}>👤 {r.technicien_nom}</div>}
                          </div>
                          <div style={{textAlign:"right"}}>
                            <div style={{fontSize:11,color:T.muted}}>{new Date(r.date_releve).toLocaleDateString("fr-FR",{day:"2-digit",month:"2-digit",year:"2-digit"})}</div>
                            {i>0&&releves[i]&&<div style={{fontSize:10,color:"#10b981",fontWeight:600}}>+{(parseInt(r.kilometrage)-(parseInt([...releves].sort((a,b)=>new Date(b.date_releve)-new Date(a.date_releve))[i+1]?.kilometrage||r.kilometrage)||0)).toLocaleString("fr-FR")}</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  );
                })()}
              </div>
            )}

            {/* Incident */}
            {vehTab==="incident"&&(
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:16}}>
                  <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:12}}>⚠️ Déclarer un incident</div>
                  <textarea value={incDesc} onChange={e=>setIncDesc(e.target.value)} rows={4} placeholder="Décrivez l'incident : choc, rayure, panne..."
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 14px",color:T.text,fontSize:14,outline:"none",width:"100%",resize:"none",boxSizing:"border-box",marginBottom:12}}/>
                  <label style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"12px",borderRadius:10,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:13,fontWeight:700,cursor:"pointer",minHeight:46,marginBottom:8,WebkitTapHighlightColor:"transparent"}}>
                    📷 Photo de l'incident (caméra)
                    <input type="file" accept="image/*" capture="environment" multiple onChange={async e=>{const imgs=await Promise.all([...e.target.files].map(compressImg));setIncPhotos(p=>[...p,...imgs]);e.target.value="";}} style={{display:"none"}}/>
                  </label>
                  <label style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"12px",borderRadius:10,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",minHeight:46,marginBottom:14,WebkitTapHighlightColor:"transparent"}}>
                    📁 Depuis la galerie
                    <input type="file" accept="image/*" multiple onChange={async e=>{const imgs=await Promise.all([...e.target.files].map(compressImg));setIncPhotos(p=>[...p,...imgs]);e.target.value="";}} style={{display:"none"}}/>
                  </label>
                  {incPhotos.length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>{incPhotos.map((src,i)=><div key={i} style={{position:"relative",width:80,height:80,borderRadius:8,overflow:"hidden"}}><img src={src} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/><button onClick={()=>setIncPhotos(p=>p.filter((_,j)=>j!==i))} style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:14,padding:"2px 6px",minWidth:26,minHeight:26}}>✕</button></div>)}</div>}
                  <button onClick={()=>{
                    if(!incDesc.trim())return;
                    const existing=storeGetA("gs_incidents_"+selVeh.immatriculation);
                    storeSet("gs_incidents_"+selVeh.immatriculation,[...existing,{id:Date.now(),description:incDesc,photos:incPhotos,gravite:"moyen",technicien:(user?.prenom||"")+" "+(user?.nom||""),date:new Date().toLocaleDateString("fr-FR"),statut:"ouvert"}]);
                    setIncDesc(""); setIncPhotos([]); saveOk("✅ Incident déclaré !");
                  }} disabled={!incDesc.trim()}
                    style={{width:"100%",padding:16,borderRadius:12,background:incDesc.trim()?"#ef4444":T.border,border:"none",color:"#fff",fontSize:15,fontWeight:800,cursor:incDesc.trim()?"pointer":"not-allowed",minHeight:54,WebkitTapHighlightColor:"transparent"}}>
                    ⚠️ Déclarer l'incident
                  </button>
                  {(()=>{const incs=storeGetA("gs_incidents_"+selVeh.immatriculation);if(!incs.length)return null;return(<div style={{marginTop:16}}><div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:8,textTransform:"uppercase"}}>Historique ({incs.length})</div>{incs.slice().reverse().map(inc=><div key={inc.id} style={{background:T.bg,borderRadius:10,border:`1px solid ${T.border}`,padding:"10px 12px",marginBottom:8}}><div style={{fontSize:11,color:T.muted,marginBottom:4}}>{inc.date}{inc.technicien?" · "+inc.technicien:""}</div><div style={{fontSize:13,color:T.text,lineHeight:1.5}}>{inc.description}</div>{inc.photos?.length>0&&<div style={{display:"flex",gap:6,marginTop:8,flexWrap:"wrap"}}>{inc.photos.map((s,i)=><img key={i} src={s} style={{width:60,height:60,borderRadius:6,objectFit:"cover"}} alt=""/>)}</div>}</div>)}</div>);})()}
                </div>
              </div>
            )}

            {/* Documents */}
            {vehTab==="docs"&&(()=>{
              const docs=apiDocs;
              return(<div style={{display:"flex",flexDirection:"column",gap:12}}>
                <div style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:14}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📄 Ajouter un document</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    {[{type:"carte_grise",nom:"Carte grise",icon:"🪪",color:"#3b82f6"},{type:"assurance",nom:"Assurance",icon:"🛡️",color:"#10b981"},{type:"ct",nom:"CT",icon:"🔧",color:"#f59e0b"},{type:"autre",nom:"Autre",icon:"📄",color:T.accent}].map(({type,nom,icon,color})=>(
                      <label key={type} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:6,padding:"16px 8px",background:T.bg,borderRadius:10,border:`1.5px dashed ${color}50`,cursor:"pointer",textAlign:"center",WebkitTapHighlightColor:"transparent"}}>
                        <input type="file" accept="image/*,application/pdf" onChange={async e=>{
                          if(!e.target.files[0])return;
                          const f=e.target.files[0];
                          const isImg=f.type.startsWith("image/");
                          const data=isImg?await compressImg(f):await new Promise(r=>{const rd=new FileReader();rd.onload=ev=>r(ev.target.result);rd.readAsDataURL(f);});
                          const tok=localStorage.getItem("nexo_token");
                          const res=await fetch(`${BASE}/vehicules/${selVeh.id}/photos`,{method:"POST",headers:{Authorization:"Bearer "+tok,"Content-Type":"application/json"},body:JSON.stringify({photos:[data],categorie:type,nom_fichier:nom})}).then(r=>r.json()).catch(()=>({}));
                          if(res.count){
                            const d=await fetch(`${BASE}/vehicules/${selVeh.id}/photos`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
                            setApiDocs((Array.isArray(d)?d:[]).filter(p=>p.categorie!=="etat"));
                            saveOk("✅ "+nom+" enregistré !");
                          } else { saveOk("❌ Erreur upload"); }
                          e.target.value="";
                        }} style={{display:"none"}}/>
                        <span style={{fontSize:26}}>{icon}</span>
                        <span style={{fontSize:11,fontWeight:700,color}}>{nom}</span>
                      </label>
                    ))}
                  </div>
                </div>
                {docs.length===0?<div style={{textAlign:"center",padding:20,color:T.muted,fontSize:13}}>📂 Aucun document enregistré</div>:docs.map(doc=>(
                  <div key={doc.id} style={{background:T.card,borderRadius:12,border:`1px solid ${T.border}`,padding:14,display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:56,height:56,borderRadius:8,overflow:"hidden",flexShrink:0,background:T.bg,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <img src={doc.url} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text}}>{doc.categorie||doc.nom_fichier}</div>
                      <div style={{fontSize:11,color:T.muted}}>{new Date(doc.created_at).toLocaleDateString("fr-FR")}</div>
                    </div>
                    <a href={doc.url} download={doc.nom_fichier||"doc.jpg"}
                      style={{padding:"10px 14px",borderRadius:8,background:T.accentDim,color:T.accent,fontSize:14,fontWeight:700,textDecoration:"none",minHeight:44,display:"flex",alignItems:"center",WebkitTapHighlightColor:"transparent"}}>
                      ⬇️
                    </a>
                  </div>
                ))}
              </div>);
            })()}
          </div>
        </div>
      )}

      {/* Lightbox mobile */}
      {lightboxMobile&&(
        <div onClick={()=>setLightboxMobile(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
          <button onClick={()=>setLightboxMobile(null)} style={{position:"absolute",top:16,right:16,background:"rgba(255,255,255,0.2)",border:"none",color:"#fff",borderRadius:10,fontSize:20,cursor:"pointer",padding:"8px 14px",minWidth:44,minHeight:44}}>✕</button>
          <a href={lightboxMobile} download="photo.jpg" onClick={e=>e.stopPropagation()}
            style={{position:"absolute",top:16,left:16,background:"rgba(255,255,255,0.2)",border:"none",color:"#fff",borderRadius:10,fontSize:13,fontWeight:700,cursor:"pointer",padding:"8px 14px",textDecoration:"none",minHeight:44,display:"flex",alignItems:"center"}}>
            ⬇️
          </a>
          <img src={lightboxMobile} onClick={e=>e.stopPropagation()} style={{maxWidth:"95vw",maxHeight:"85vh",borderRadius:8,objectFit:"contain"}} alt=""/>
        </div>
      )}

      {/* Nav */}
      <nav style={{position:"fixed",bottom:0,left:0,right:0,background:T.card,borderTop:`1px solid ${T.border}`,display:"flex",justifyContent:"space-around",alignItems:"center",paddingTop:6,paddingBottom:"max(12px,env(safe-area-inset-bottom))",zIndex:200}}>
        {NAV.map(n=>(
          <button key={n.id} onClick={()=>setTab(n.id)}
            style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2,background:"none",border:"none",cursor:"pointer",color:tab===n.id?T.accent:T.muted,padding:"2px 6px",borderRadius:8,minWidth:44,position:"relative"}}>
            {n.id==="sav"&&openSAV>0&&<div style={{position:"absolute",top:-2,right:4,width:8,height:8,borderRadius:"50%",background:T.danger}}/>}
            <span style={{fontSize:22}}>{n.ic}</span>
            <span style={{fontSize:9,fontWeight:tab===n.id?700:400}}>{n.lbl}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
